// Types
import mixins from "vue-typed-mixins";
// Enums
import { Modals } from '../../enums/Modals';

// Mixins
import CartModalEvents from './CartModalEvents';

// Components
import { CartModalView } from '../overridableComponents';
const CartModal = mixins(CartModalEvents).extend({
  components: {
    CartModalView
  },
  provide() {
    return {
      isCartView: true
    };
  },
  render() {
    const h = arguments[0];
    return h("modal", {
      "attrs": {
        "name": Modals.Cart,
        "id": Modals.Cart,
        "height": "80%",
        "width": "90%",
        "clickToClose": true
      }
    }, [h(CartModalView, {
      "on": {
        "close": () => {
          this.$modal.hide(Modals.Cart);
        }
      }
    })]);
  }
});
export default CartModal;